import React, { useState } from 'react';
import logo from './assets/header/logo_neu.webp';
import SideNav from './SideNav';
import PrivacyModal from './PrivacyModal';
import ImpressumModal from './ImpressumModal';
import { useLanguage } from './LanguageContext';
import OptimizedImage from './components/OptimizedImage';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  const handleLogoClick = (e) => {
    e.preventDefault();
    const welcomeSection = document.getElementById('willkommen');
    if (welcomeSection) {
      const headerHeight = 60;
      const elementPosition = welcomeSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const headerWrapperStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    borderBottom: '3px solid #cec800',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center'
  };

  const headerStyle = {
    width: '100%',
    maxWidth: '950px',
    padding: '1rem 0.8rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: '60px'
  };

  const rightSectionStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  };

  const languageSelectorStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#666666',
    fontSize: '0.9rem',
    fontFamily: 'Sora, sans-serif',
    cursor: 'pointer'
  };

  const activeLanguageStyle = {
    fontWeight: '700'
  };

  const inactiveLanguageStyle = {
    fontWeight: '400'
  };

  const separatorStyle = {
    color: '#666666',
    opacity: '0.5'
  };

  const logoStyle = {
    height: '60px',
    width: 'auto',
    objectFit: 'contain',
    cursor: 'pointer'
  };

  const menuButtonStyle = {
    backgroundColor: '#666666',
    color: 'white',
    border: 'none',
    borderRadius: '50px',
    padding: '0.8rem 2.5rem',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '400',
    letterSpacing: '1px'
  };

  const burgerMenuStyle = {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  };

  const burgerLineStyle = {
    width: '25px',
    height: '3px',
    backgroundColor: '#cec800',
    margin: '3px 0'
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div style={headerWrapperStyle}>
        <header style={headerStyle}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
            <a href="#willkommen" onClick={handleLogoClick}>
              <OptimizedImage src={logo} alt="physiotherapiezentrum uwe veronik" style={logoStyle} />
            </a>
            <div style={rightSectionStyle}>
              <div style={languageSelectorStyle} onClick={toggleLanguage}>
                <span style={language === 'de' ? activeLanguageStyle : inactiveLanguageStyle}>de</span>
                <span style={separatorStyle}>|</span>
                <span style={language === 'en' ? activeLanguageStyle : inactiveLanguageStyle}>en</span>
              </div>
              <div style={burgerMenuStyle} onClick={() => setIsNavOpen(!isNavOpen)}>
                <div style={burgerLineStyle}></div>
                <div style={burgerLineStyle}></div>
                <div style={burgerLineStyle}></div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <SideNav 
        isOpen={isNavOpen} 
        onClose={() => setIsNavOpen(false)}
        onOpenPrivacy={() => setIsPrivacyOpen(true)}
        onOpenImpressum={() => setIsImpressumOpen(true)}
      />
      <PrivacyModal 
        isOpen={isPrivacyOpen} 
        onClose={() => setIsPrivacyOpen(false)} 
      />
      <ImpressumModal 
        isOpen={isImpressumOpen} 
        onClose={() => setIsImpressumOpen(false)} 
      />
    </>
  );
};

export default Header; 